// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 2rem;
  gap: 1.2rem;
}

.format-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 1px;
}
.format-badge ion-icon {
  font-size: 1.2rem;
}

.percentage-text {
  font-size: 3rem;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 1;
  color: var(--ion-color-medium);
}

.progress-bar-track {
  width: 100%;
  height: 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.15);
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 6px;
  background: var(--ion-color-medium);
  transition: width 0.4s ease;
}

.hint-text {
  font-size: 0.85rem;
  opacity: 0.6;
  text-align: center;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/modals/export-progress-modal/export-progress-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,8BAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;AAAF;;AAGA;EACE,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,2BAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AAAF","sourcesContent":[".export-progress-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2.5rem 2rem;\n  gap: 1.2rem;\n}\n\n.format-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  padding: 6px 16px;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: 1px;\n\n  ion-icon {\n    font-size: 1.2rem;\n  }\n}\n\n.percentage-text {\n  font-size: 3rem;\n  font-weight: 700;\n  letter-spacing: 1px;\n  line-height: 1;\n  color: var(--ion-color-medium);\n}\n\n.progress-bar-track {\n  width: 100%;\n  height: 10px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.15);\n  overflow: hidden;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  border-radius: 6px;\n  background: var(--ion-color-medium);\n  transition: width 0.4s ease;\n}\n\n.hint-text {\n  font-size: 0.85rem;\n  opacity: 0.6;\n  text-align: center;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
